import axios from "axios";
import config from "src/config";
import { signOut } from "src/redux/auth/action";

const VERSION_URL = config.VERSION_URL as string
const POLL_MS = 30000
const APP_VERSION = "app_version";

let timer: number | null = null;
let running = false;

async function checkOnce() {
  const res = await axios.get(VERSION_URL);

  const next = String(res.data?.version ?? "");
  if (!next) return; // ignore bad payloads

  const prev = localStorage.getItem(APP_VERSION);

  if (!prev) {
    localStorage.setItem(APP_VERSION, next); // first run: record and move on
    return;
  }

  if (next !== prev) {
    localStorage.setItem(APP_VERSION, next);
    signOut(localStorage.getItem("username") ?? "");
    window.location.reload()
  }
}

function schedule() {
  if (timer) clearInterval(timer);
  timer = window.setInterval(() => {
    // skip background tabs to save calls; remove if you want constant polling
    if (document.hidden) return;

    checkOnce().catch(() => {
      // swallow errors: we'll try again on next tick
    });
  }, POLL_MS);
}

export function startVersionPoller() {
  if (running) return;
  running = true;

  // quick initial check
  checkOnce().catch(() => { /* ignore first failure */ });

  // poll at interval
  schedule();

  // when tab regains focus, check immediately
  document.addEventListener("visibilitychange", () => {
    if (!running) return;
    if (document.visibilityState === "visible") {
      checkOnce().catch(() => {});
    }
  });
}

export function stopVersionPoller() {
  running = false;
  if (timer) clearInterval(timer);
  timer = null;
}
